// @flow
import React, { PureComponent } from 'react';
import type { Element } from 'react';
import styled from 'styled-components';

import ContentBlock from '../content-block';
import { isThemeiOS } from '../../themes';
import AndroidTrash from '../../icons/android-trash.svg';

type Props = {
  item: Element<*>,
  canEdit: boolean,
  canDelete: boolean,
  renderItem: (Element<*>) => Element<*>,
  onDelete: Function,
  DragHandle?: Element<*>
};

const ListItem = styled(ContentBlock)`
  background-color: inherit;
  box-sizing: border-box;
  list-style-type: none;
  overflow: hidden;

  &.sortable-helper {
    outline: 1px solid #c8c7cc;
    z-index: 10000;

    & .item-title {
      overflow: hidden;
    }

    & .item-after {
      padding-left: 5px;
    }
  }

  & .fb-text {
    font-size: 17px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AndroidDeleteButton = styled.div.attrs({
  dangerouslySetInnerHTML: {
    __html: AndroidTrash
  }
})`
  ${({ disabled }) => disabled ? 'display: none;' : ''}
  background-color: transparent;
  border: 0;
  flex-grow: 0;
  height: 18px;
  margin-right: 32px;
  padding: 0;
  width: 14px;
  > svg {
    fill: #EF426F;
    height: 18px;
  }
`;

const IOSDeleteButton = styled.div`
  ${({ disabled }) => disabled ? 'display: none;' : ''}
  background-color: #CCCCCC;
  border-radius: 100px;
  color: white;
  font-size: 12px;
  height: 22px;
  min-width: 22px;
  line-height: 22px;
  margin: 0 10px 0 0;
  text-align: center;
`;

const ItemTitle = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 10;
  font-size: 17px;
  overflow: hidden;
`;

export default class extends PureComponent<Props, void> {
  renderiOSDeleteBtn = (onDelete: Function, canDelete: boolean) => (
    <IOSDeleteButton onClick={onDelete} disabled={!canDelete}>
      &#10006;&#xFE0E;
    </IOSDeleteButton>
  )

  renderAndroidDeleteBtn = (onDelete: Function, canDelete: boolean) => (
    <AndroidDeleteButton
      onClick={onDelete}
      disabled={!canDelete}
    />
  )

  render() {
    const {
      item,
      canEdit,
      canDelete,
      renderItem,
      onDelete,
      DragHandle,
      ...props
    } = this.props;
    return (
      <ListItem {...props}>
        <FlexContainer>
          {canEdit && isThemeiOS() &&
            this.renderiOSDeleteBtn(onDelete, canDelete)
          }
          <ItemTitle>
            {renderItem(item)}
          </ItemTitle>
          {canEdit && !isThemeiOS() &&
            this.renderAndroidDeleteBtn(onDelete, canDelete)
          }
          <div>
            {canEdit && <DragHandle />}
          </div>
        </FlexContainer>
      </ListItem>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Item/item.js